<template>
  <div>
    <div class="user-nav">
      <a class="active" href="javascript:;">公司转账</a>
    </div>
    <div class="open-content">
      <p><span>收款人：</span>中国对外承包工程商会</p>
      <p><span>开户行：</span>交通银行股份有限公司北京五棵松支行</p>
      <p><span>账号：</span>11006 14500 1880 0019 600</p>
      <!-- <p>请在转帐附言或备注中注明“技术咨询服务”。</p> -->
    </div>
    <h3 style="color: red;font-size: 16px">注意事项</h3>
    <p style="font-size: 14px">请在转帐附言或备注中注明“技术咨询服务”。</p>
  </div>
</template>
<script>
  export default {
    name: 'OpenVip',
    data (){
      return {
        account:'中国对外承包工程商会',
        cardNum:'11006 14500 1880 0019 600',
        accountUser:'交通银行股份有限公司北京五棵松支行',
        // tel: '028-12345678'
      }
    },
    mounted (){
      this.getBankInfo()
    },
    methods: {
      getBankInfo (){
        this.$ajax.get('/common/bankAccout')
          .then(res =>{
            if(res.status === 200 && res.data){
              this.account = res.data.bank
              this.cardNum = res.data.card
              this.accountUser = res.data.handler
              this.tel = res.data.phone
            }
          })
      }
    }
  }
</script>
<style lang="scss">
@import "../../style/user-nav";
  .open-content{
    border: 1px solid #ccc;
    padding: 15px 20px;
    background: #f8f8f8;
    p{
      line-height: 26px;
      span{
        display: inline-block;
        margin-right: 5px;
        width: 80px;
        text-align: justify;
        text-align-last: justify;
        color: #8a8a8a;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/user/OpenVip.vue